import state from "./shopState.js";
import actions from "./shopAction.js";
import mutations from "./shopMutation.js";
import getters from "./shopGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
